import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Modal, TextInput } from "flowbite-react"
import { HiOutlineDocumentAdd, HiOutlineBookOpen } from "react-icons/hi";
import { FaRegTimesCircle } from 'react-icons/fa';
import { registerWineMenu } from '../../redux/menuReducer';
import { openSnackBar } from '../../redux/snackBarReducer';
import swal from 'sweetalert2';
import { createWineMenuSearchText } from '../../utils'
import Loading from "../Global/Loading";
import { useTranslation } from "react-i18next";

function Menu(props) {
    const { t } = useTranslation();
    const { authState, globalState, menuState } = useSelector((state) => state);
    const { userInfo } = authState;
    const { createWineMenuState } = menuState;
    const { menuCondition } = globalState;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
    }, [])


    const [modalShow, setModalShow] = useState(false);    //modal modalShow hide
    const [search, setSearch] = useState("");   //search bar text 

    const changeSearch = (e) => {
        setSearch(e.target.value);
    }

    const createWineMenu = async () => {
        if (search) {
            const { name } = userInfo;
            const formData = new FormData();
            let search_field = createWineMenuSearchText({ menu_name: search, user_name: name, created_at: new Date().toLocaleString() });
            formData.append("user_id", menuCondition.user_id);
            formData.append("company", menuCondition.company);
            formData.append("isGlobal", menuCondition.isGlobal);
            formData.append("role", menuCondition.role);
            formData.append("menu_name", search);
            formData.append("search_field", search_field);
            const res = await dispatch(registerWineMenu(formData))
            if (res) {
                dispatch(openSnackBar({ message: t("msg_success_create_menu"), status: 'success' }));
                navigate('/menuedit');
            } else {
                dispatch(openSnackBar({ status: "error", message: t("msg_menu_exist") }));
            }
        } else {
            dispatch(openSnackBar({ message: t("msg_fill_menu"), status: 'error' }));
        }
    }

    const closeModal = () => {
        swal.fire({
            title: t("swal_are_you_sure"),
            text: t("swal_leave_page"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("swal_leave")
        })
            .then(result => {
                if (result.isConfirmed) {
                    close();
                }
            });

    }

    function close() {
        setModalShow(false);
    }

    return (
        <>
            <Button color={'red'} onClick={() => setModalShow(true)} outline={false} className="bg-indigo-500 text-white hover:bg-indigo-400 w-500 flex-system-space-around " style={{width:'240px'}} >
                {/* <HiOutlineDocumentAdd className="mr-2 h-6 w-6 text-white" /> */}
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-4 w-4 text-white" stroke-width="1.5">
                    <path d="M16.5,21.513a1.5,1.5,0,0,1-1.9,1.446L4.1,20.042A1.5,1.5,0,0,1,3,18.6V2.487A1.5,1.5,0,0,1,4.9,1.041L15.4,4.432a1.5,1.5,0,0,1,1.1,1.445Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.5.987h15a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5h-3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {t("create_new_wine_menu")}
            </Button>
            <Modal
                show={modalShow}
                size="xl"
                popup={true}
                onClose={() => closeModal()}>
                <Modal.Header className="py-5 pl-6 pr-5">
                    {t("create_new_wine_menu")}
                </Modal.Header>
                <hr />
                <Modal.Body>
                    {createWineMenuState && <Loading />}
                    <div className="py-6">
                        <div className="m-2 ml-2 text-sm block">
                            {t("wine_menu_name")}<span className='text-red-700'>*</span>
                        </div>
                        <TextInput
                            id="searchmenu"
                            type="search"
                            sizing="lg"
                            // placeholder="Wine Menu Name"
                            required={true}
                            // icon={HiOutlineSearch}
                            value={search}
                            onChange={(e) => changeSearch(e)}
                        />
                    </div>
                </Modal.Body>
                <hr />
                <Modal.Footer>
                    <div className="flex flex-wrap gap-4 m- flex-system-space-around auto">
                        <div>
                            <Button color={'red'} onClick={() => closeModal()} className="btn border-slate-200 hover--border-slate-300 text-red-500">
                                {/* <FaRegTimesCircle className="mr-2 h-5 w-5" /> */}
                                <svg viewBox="0 0 24 24" className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" stroke-width="1.5"><path d="M15.182 8.818L8.818 15.181" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.818 8.818L15.182 15.181" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round"/><path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z" fill="none" stroke="red" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                {t("dismiss")}
                            </Button>
                        </div>
                        <div>
                            <Button color={'red'} onClick={() => createWineMenu()} outline={false} className="bg-indigo-500 text-white hover:bg-indigo-400" >
                                {/* <HiOutlineBookOpen className="mr-2 h-6 w-6 text-white" /> */}
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="mr-2 h-4 w-4 text-white" stroke-width="1.5">
                    <path d="M16.5,21.513a1.5,1.5,0,0,1-1.9,1.446L4.1,20.042A1.5,1.5,0,0,1,3,18.6V2.487A1.5,1.5,0,0,1,4.9,1.041L15.4,4.432a1.5,1.5,0,0,1,1.1,1.445Z" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4.5.987h15a1.5,1.5,0,0,1,1.5,1.5v15.75a1.5,1.5,0,0,1-1.5,1.5h-3" fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                {t("create_new_wine_menu")}
                            </Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Menu;
